 export class ReservationServiceValidator {
   static validateReservationData(reservationData: any): boolean {
      return reservationData
        && reservationData.stay
        && reservationData.stay.hotelMnemonic
        && reservationData.guest
        && reservationData.confirmationNumbers
        && reservationData.confirmationNumbers.length
        && reservationData.confirmationNumbers[0].ihgConfirmationNumber;
   }

   static validateRateRulesData(rateRulesData: any): boolean {
     return rateRulesData
       && rateRulesData.room
       && rateRulesData.rate;
   }

   static validateAvailSinglePropData(availBody: any): boolean {
    return availBody
      && availBody.hotels
      && availBody.hotels[0]
      && availBody.hotels[0].rateDetails
      && availBody.hotels[0].rateDetails.offers
      && availBody.hotels[0].rateDetails.offers[0]
      && availBody.hotels[0].rateDetails.offers[0].availableStatus
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/validators/reservation.validator.ts